export const ro = {
    firstLogin: {
        tabName: 'Creează cont',
        title: 'Creează cont ',
        subTitle: 'Introdu id-ul unic',
        createAccountSubTitle: 'Introdu numele de utilizator și parola',
        idFormPlaceholder: 'Id unic',
        usernamePlaceholder: 'Numele de utilizator',
        passwordPlaceholder: 'Parola',
        buttonNext: 'Mai departe',
        buttonCreate: 'Creează cont',
    },
    generalLogin: {
        tabName: 'Intră in cont',
        title: 'Intră in cont',
        subTitle: 'Introdu numele de utilizator și parola',
        usernamePlaceholder: 'Numele de utilizator',
        passwordPlaceholder: 'Parola',
        button: 'Conectare',
        forgotPassword: 'ai uitat parola?',
        modalHeader: 'Generează un link de resetare',
        modalInstructions1: 'Introdu adresa de e-mail',
        modalInstructions2: 'Dacă nu ai o adresă de e-mail asociată contului, contactează-ți managerul',
        modalButton: 'Trimite',
    },
    navBar: {
        home: 'Acasă',
        learningPlans: 'Planuri de invățare',
        logOut: 'Deconectează-te',
    },
    userDashboard: {
        pageName: 'Onboarding',
        continueCourses: 'Continuă de unde ai rămas',
        onboardingCourses: 'Planul tău de înrolare',
        finishedCourses: 'Cursuri terminate',
        emptyContinueCourses: 'Nu ai cursuri active.',
        emptyOnboardingCourses: 'Feliciări!🎊 Ai terminat toate cursurile.',
        emptyFinishedCourses: 'Nu ai terminat niciun curs inca',
    },
    course: {
        numberOfPages: 'Număr de pagini: ',
        startCourse: 'Începe Cursul',
        nextPage: 'Pagina următoare',
        previousPage: 'Pagina anterioara',
        goodJob: 'Felicitări!🎊',
        youFinished: 'Ai terminat cursul ',
        startTest: 'Începe chestionarul',
        submitQuestion: 'Răspunde',
        correctAnswer: 'Răspunsul corect',
        finishCourse: 'Termină cursul',
    },
    questionnaire: {
        questionnaire: 'Chestionar',
        questions: 'întrebări',
        info1: 'Examenul va fi evaluat automat.',
        info2: 'Pentru a promova, trebuie să obțineți o notă de cel puțin 7.',
        info3: 'În cazul în care nu promovați examenul, va fi necesar să repetați cursul.',
        info4: '* Aveți posibilitatea de a revizui și modifica răspunsurile dumneavoastră în orice moment.',
        info5: '  * Vă rugăm să rețineți că odată ce ați răspuns la o întrebare, nu mai puteți modifica răspunsul.',
        startExam: 'Începe testul',
        previousQuestion: 'Întrebarea anterioară',
        nextQuestion: 'Întrebarea următoare',
        finishExam: 'Termină testul',
        dialogMessage1: 'Sigur vrei să termini testul?',
        dialogMessage2: 'Atenție, nu te mai poți întoarce la întrebări!',
        dialogHeader: 'Confirmare',
        anwser: 'Răspunde',
        correctAnwser: 'Răspunsul corect: ',
        goodJob: 'Felicitări!🎊',
        gradeText: 'Ai obținut nota ',
        youResponded: 'Ai răspuns corect la',
        anwsers: 'Răspunsuri',
        yourAnwser: 'Tu ai răspuns',
        backToCourses: 'Înapoi la cursuri',
    },
    learningPlans: {
        title: 'Planuri de învățare',
        noPlans: 'Nu există planuri de inățare pentru această poziție',
        lastUpdate: 'Ultima actualizare',
        seeCourses: 'Vezi Cursurile',
        openPlan: 'Deschide Planul',
        continueCourses: 'Continuă de unde ai rămas',
        planCourses: 'Cursurile planului',
        finishedCourses: 'Cursuri terminate',
    },
    resetPassword: {
        header: 'Resetează parola',
        subTitle1: 'Dacă nu ești tu',
        subTitle2: 'ignoră acest link.',
        usernamePlaceholder: 'Username',
        passwordPlaceholder: 'Parolă',
        button: 'Schimbă parola',
        noData1: 'Oops! Acest link nu există.',
        noData2: 'Contactează-ți managerul.',
        expired1: 'Oops! Acest link a expirat.',
        expired2: 'Contactează-ți managerul.',
    },
};
